module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-hollandsnieuwe-intro-card1.1.1e11af44.jpg";